import {
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import React from 'react';

import OperationResume from '../OperationResume';

type ProductSelectorProps = {
  business: {
    businessName: string;
    identifier: string;
  };
  productType: 'traditional' | 'earlyPayment';
  setProductType: (productType: 'traditional' | 'earlyPayment') => void;
};

const ProductSelector = (props: ProductSelectorProps) => {
  const { business, productType, setProductType } = props;
  return (
    <div>
      <OperationResume
        stakeholderName={business.businessName}
        stakeholderIdentifier={business.identifier}
      />
      <Divider />
      <div style={{ padding: '20px 0px' }}>
        <Typography variant="h6">Selecciona el tipo de producto</Typography>
        <FormControl margin="dense" fullWidth>
          <InputLabel id="product-type-label">Tipo de producto</InputLabel>
          <Select
            labelId="product-type-label"
            id="product-type-select"
            fullWidth
            value={productType}
            onChange={(e) =>
              setProductType(e.target.value as 'traditional' | 'earlyPayment')
            }
            label="Tipo de producto"
          >
            <MenuItem value="traditional">Tradicional</MenuItem>
            <MenuItem value="earlyPayment">Pronto Pago</MenuItem>
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

export default ProductSelector;
